import { render, staticRenderFns } from "./NewMainPageBottom.vue?vue&type=template&id=76474504&scoped=true&"
import script from "./NewMainPageBottom.vue?vue&type=script&lang=js&"
export * from "./NewMainPageBottom.vue?vue&type=script&lang=js&"
import style0 from "./NewMainPageBottom.vue?vue&type=style&index=0&id=76474504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76474504",
  null
  
)

export default component.exports
import TouchPan from 'quasar/src/directives/TouchPan.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'directives', {TouchPan});
